<template>
    <div>
        <limitless-page-header>
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'address_lists.edit', params: { id: 0 } }" icon="icon-plus3">Ny lista</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/address_lists'" :columns="table_columns" :filter="table_filter" sort-by="id" sort-order="desc" @updateFilter="table_filter=$event" @rowclick="rowClick" history :per-page="100">
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { formatDateTime } from '@services/Helpers';

export default {
    name: 'AddressLists',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
        },
        table_columns: [
            {
                data: 'id',
                header: '#',
                sortable: true,
            },
            {
                data: 'name',
                header: 'Namn',
                sortable: true,
            },
            {
                data: 'created_at',
                header: 'Skapad',
                sortable: true,
                render(row) {
                    return formatDateTime(row.created_at).substring(0, 16);
                },
            },
            {
                data: 'updated_at',
                header: 'Ändrad',
                sortable: true,
                render(row) {
                    return formatDateTime(row.created_at).substring(0, 16);
                },
            },
        ],
    }),
    methods: {
        rowClick(data, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                const route = this.$router.resolve({ name: 'address_lists.edit', params: { id: data.id } });
                window.open(route.href, '_blank').focus();
            } else {
                this.$router.push({ name: 'address_lists.edit', params: { id: data.id } });
            }
        },
    },
};

</script>
